import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'
import { GetDcAllInput, GetDcAllResponse } from './interface'

export const getDcAllList = async (
    input: GetDcAllInput
  ): Promise<GetDcAllResponse> => {
    const data: AxiosResponse<GetDcAllResponse> = await httpClient
      .post(API.getDcAllList, input)
      .catch((error) => handleResponseError(error))
    return data.data
  }